export default __webpack_public_path__ + "static/Anique.JP_Logo-da451d618a5a6d4b1c07ff7099a74199.svg";